
export default function() {
  
  
  $(".map-container").each(function() {
    var $this=$(this).css("min-height", "100vh").css("margin", "0 -8.5%");
    var coords=$this.attr("data-coords").split(",");
    var apiKey=$this.attr("data-apikey");
    var script=$("<script />", {src: "https://maps.googleapis.com/maps/api/js?key="+apiKey+"&callback=iesInitMap"}).appendTo("body");
    window.iesInitMap=function() {
      var map = new google.maps.Map($this[0], {
        center: { lat: coords[0]*1, lng: coords[1]*1 },
        zoom: 12,
      });
    }
  });
  
}
